//@flow
//Action Type Registered
export const KRATOS_EC_DOC_SUBMIT_SUCCESS='KRATOS_EC_DOC_SUBMIT_SUCCESS'
export const KRATOS_EC_DOC_SUBMIT_ERROR='KRATOS_EC_DOC_SUBMIT_ERROR'
export const KRATOS_EC_DOC_SUBMITTED_COMPLETED='KRATOS_EC_DOC_SUBMITTED_COMPLETED'
export const EDIT_KRATOS_EC_VERIFY_FORM_DATA_SUCCESS='EDIT_KRATOS_EC_VERIFY_FORM_DATA_SUCCESS'
export const EDIT_KRATOS_EC_VERIFY_FORM_DATA_ERROR='EDIT_KRATOS_EC_VERIFY_FORM_DATA_ERROR'


// WEBPACK FOOTER //
// ./src/redux/kratosec/actionTypes.js